import React from "react";
import { useSelector } from "react-redux";
import Avatar from "../inputs/Avatar";
import PostCommunityComment from "../../components/cards/PostCommunityComment";
import { displayDate } from "../../utils/arabicDatesUtilities";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const PostCommunityCard = ({
  post,
  handleToggleLike,
  handleSubmittingComment,
  setPostId,
  containerClassName,
  readOnlyInteractions,
  profileBasePath,
  onToggleCommentLike,
}) => {
  const currentUser = useSelector((state) => state.auth.currentUser);
  let navigate = useNavigate();
  const { t } = useTranslation(["communityFeed", "common"]);

  const basePath = profileBasePath || "/employee/profile";

  const navigateToUserprofile = () =>
    navigate(`${basePath}/${post.user.id}`);

  const canDelete = post?.user?.id == currentUser?.id;

  return (
    <div className={`card-style post-community-card ${containerClassName}`}>
      <div className="post-community-card__header d-flex flex-wrap align-items-start mb-4">
        <div className="post-community-card__author d-flex align-items-center">
          <Avatar width="60" height="60" avatarUrl={post?.user?.avatar_url} />
          <div className="ms-2 post-community-card__author-info">
            <h1
              onClick={navigateToUserprofile}
              role="button"
              className="mb-0 font_18 font-extrabold clickable text-truncate"
            >
              {post?.user?.name}
            </h1>
            {post?.user?.department?.name && (
              <p className="mb-0 font_14 font-color-grey text-truncate">
                {post?.user?.department?.name}
              </p>
            )}
            <p className="mb-0 font_13 post-community-card__date text-truncate">
              {displayDate(post?.created_at)}
            </p>
          </div>
        </div>

        {canDelete && (
          <div className="post-community-card__meta">
            <button
              type="button"
              className="post-community-card__delete-btn"
              data-bs-toggle="modal"
              data-bs-target="#confirmation-modal"
              onClick={() => setPostId(post?.id)}
              aria-label={t("communityFeed:remove")}
              title={t("communityFeed:remove")}
            >
              <span className="fas fa-trash-alt" aria-hidden="true"></span>
            </button>
          </div>
        )}
      </div>

      <div
        className="post-community-card__content"
        style={{ whiteSpace: "pre-wrap" }}
      >
        <p className="mb-0 font_16 mb-4 font-bold text-break">{post?.body}</p>

        {post?.image_urls?.length > 0 && (
          <img
            className="img"
            alt=""
            style={{ width: "100%" }}
            src={post?.image_urls[0]}
          />
        )}
      </div>

      <div>
        <PostCommunityComment
          post={post}
          handleToggleLike={handleToggleLike}
          handleSubmittingComment={handleSubmittingComment}
          readOnlyInteractions={readOnlyInteractions}
          profileBasePath={basePath}
          onToggleCommentLike={onToggleCommentLike}
        />
      </div>
    </div>
  );
};

export default PostCommunityCard;

PostCommunityCard.propTypes = {
  containerClassName: PropTypes.string,
};

PostCommunityCard.defaultProps = {
  containerClassName: "",
  readOnlyInteractions: false,
  profileBasePath: "/employee/profile",
};
